module.exports = new __parcel__URL__("checkIconWhite.d4952764.svg").toString();